"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPeriod = void 0;
var math_1 = require("../common/math");
function formatPeriod(period) {
    if ((0, math_1.inRange)(period, 10, 20)) {
        return "".concat(period, "th Period");
    }
    var lastDigit = period % 10;
    switch (lastDigit) {
        case 1:
            return "".concat(period, "st Period");
        case 2:
            return "".concat(period, "nd Period");
        case 3:
            return "".concat(period, "rd Period");
        default:
            return "".concat(period, "th Period");
    }
}
exports.formatPeriod = formatPeriod;
//# sourceMappingURL=announcements.js.map